export const URLS = {
  request: 'api/notificationrequest'
}